import {PATH_LOGIN, PATH_USER_PROFILE} from '../navigation/navigation.module';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {PERM_ACCIONES_ID, PermisosService} from '@services/permisos-service';
import {environment} from '../../environments/environment';
import {NavigationService} from '@services/navigation-service';

@Injectable()
export class IndicadoresGuard implements CanActivate {

  /**
   * Este Guard se usa para los casos de redireccionamientos automaticos a HOME. Dado que no todos tienen indicadores
   * por permiso, no todos tendran la misma HOME, es por esto que usamos este guard. Deberiamos tener una sola HOMEPAGE disponible para
   * TODOS, cuando esto suceda este guard quedará obsoleto.
  * **/

  /**
   * Update: Redireccion basada en permisos: De acuerdo con la nueva normativa dispuesta por la casa central la nueva home estara basada
   * en el permiso y el primer valor que tenga disponible en el menu lateral y en caso de no haber opciones allí se redirige al perfil
   * */

  /**
   * Update 2: Estamos aqui reunidos para despedir a este gran guard el cual pereció producto de la innovacion furiosa de fede y lo obligó
   * a revelarse contra el sistema causando un loop infinito. Gracias por sus servicios soldado. Queda usted relevado de sus funciones.
   * La nueva pag de inicio toma el control.
   * */

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    window.open(environment.EXTERNAL_BASE_URL + '/inicio', '_self');
    return false;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/guards/indicadores-guard.ts